export default "__VITE_ASSET__Dpv1z6nw__"